import React, { useState } from "react";
import { auth } from "./firebase";
import { signInWithPhoneNumber, RecaptchaVerifier } from "firebase/auth";

function Login() {
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [message, setMessage] = useState("");

  const setupReCAPTCHA = () => {
    if (!window.recaptchaVerifier) {
      window.recaptchaVerifier = new RecaptchaVerifier(
        "recaptcha-container",
        {
          size: "invisible",
          callback: (response) => {
            console.log("reCAPTCHA solved:", response);
          },
          "expired-callback": () => {
            console.warn("reCAPTCHA expired");
          },
        },
        auth
      );
      // ⛔ REQUIRED TO PREVENT captcha-check-failed
      window.recaptchaVerifier.render().then((widgetId) => {
        window.recaptchaWidgetId = widgetId;
      });
    }
  };

  const sendOTP = async () => {
    setMessage("");
    setupReCAPTCHA();
    const appVerifier = window.recaptchaVerifier;

    try {
      const confirmation = await signInWithPhoneNumber(
        auth,
        phone,
        appVerifier
      );
      window.confirmationResult = confirmation;
      setMessage("✅ OTP sent to " + phone);
    } catch (error) {
      console.error(error);
      setMessage("❌ Error: " + error.message);
    }
  };

  const verifyOTP = async () => {
    try {
      await window.confirmationResult.confirm(otp);
      setMessage("✅ Phone verified!");
    } catch (err) {
      console.error(err);
      setMessage("❌ Invalid OTP: " + err.message);
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>Phone Auth with reCAPTCHA</h2>
      <input
        type="text"
        placeholder="+972501234567"
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
      />
      <br />
      <br />
      <button onClick={sendOTP}>Send OTP</button>

      {/* REQUIRED FOR RECAPTCHA */}
      <div id="recaptcha-container"></div>

      <br />
      <br />
      <input
        type="text"
        placeholder="Enter OTP"
        value={otp}
        onChange={(e) => setOtp(e.target.value)}
      />
      <br />
      <br />
      <button onClick={verifyOTP}>Verify OTP</button>

      <p>{message}</p>
    </div>
  );
}

export default Login;
